import { ReactElement } from "react";

interface IProps {
  condition1: boolean;
  renderIf1True: ReactElement | null;
  condition2?: boolean;
  renderIf2True?: ReactElement | null;
  condition3?: boolean;
  renderIf3True?: ReactElement | null;
  renderDefault?: ReactElement | null;
}

const ConditionalRender = (props: IProps) => {
  if (props.condition1) {
    return props.renderIf1True;
  } else if (props.condition2) {
    return props.renderIf2True as ReactElement;
  } else if (props.condition3) {
    return props.renderIf3True as ReactElement;
  }
  return props.renderDefault || null;
};

export default ConditionalRender;
